import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import {
  DutyOffParams,
  DutyOnParams,
} from 'src/app/shared/flight-log-api/duty-logs/duty-log-client.service';
import { DutyLogEntity } from './duty-log.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum DutyLogActionTypes {
  LoadDutyLogs = '[DutyLog] Load DutyLogs',
  AddDutyLog = '[DutyLog] Add DutyLog',
  UpsertDutyLog = '[DutyLog] Upsert DutyLog',
  AddDutyLogs = '[DutyLog] Add DutyLogs',
  UpsertDutyLogs = '[DutyLog] Upsert DutyLogs',
  UpdateDutyLog = '[DutyLog] Update DutyLog',
  UpdateDutyLogs = '[DutyLog] Update DutyLogs',
  DeleteDutyLog = '[DutyLog] Delete DutyLog',
  DeleteDutyLogs = '[DutyLog] Delete DutyLogs',
  ClearDutyLogs = '[DutyLog] Clear DutyLogs',
  DutyLogEdited = '[DutyLog] Edited',
  DutyOn = '[DutyLog] Duty On',
  DutyOff = '[DutyLog] Duty Off',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class DutyOn implements Action {
  public readonly type = DutyLogActionTypes.DutyOn;
  constructor(public readonly payload: DutyOnParams) {}
}

export class DutyOff implements Action {
  public readonly type = DutyLogActionTypes.DutyOff;
  constructor(public readonly payload: DutyOffParams) {}
}

export class DutyLogEdited implements Action {
  public readonly type = DutyLogActionTypes.DutyLogEdited;
  constructor(public payload: { id: string }) {}
}

export class LoadDutyLogs implements Action {
  public readonly type = DutyLogActionTypes.LoadDutyLogs;

  constructor(public payload: { dutyLogs: DutyLogEntity[] }) {}
}

export class AddDutyLog implements Action {
  public readonly type = DutyLogActionTypes.AddDutyLog;

  constructor(public payload: { dutyLog: DutyLogEntity }) {}
}

export class UpsertDutyLog implements Action {
  public readonly type = DutyLogActionTypes.UpsertDutyLog;

  constructor(public payload: { dutyLog: DutyLogEntity }) {}
}

export class AddDutyLogs implements Action {
  public readonly type = DutyLogActionTypes.AddDutyLogs;

  constructor(public payload: { dutyLogs: DutyLogEntity[] }) {}
}

export class UpsertDutyLogs implements Action {
  public readonly type = DutyLogActionTypes.UpsertDutyLogs;

  constructor(public payload: { dutyLogs: DutyLogEntity[] }) {}
}

export class UpdateDutyLog implements Action {
  public readonly type = DutyLogActionTypes.UpdateDutyLog;

  constructor(public payload: { dutyLog: Update<DutyLogEntity> }) {}
}

export class UpdateDutyLogs implements Action {
  public readonly type = DutyLogActionTypes.UpdateDutyLogs;

  constructor(public payload: { dutyLogs: Update<DutyLogEntity>[] }) {}
}

export class DeleteDutyLog implements Action {
  public readonly type = DutyLogActionTypes.DeleteDutyLog;

  constructor(public payload: { id: string }) {}
}

export class DeleteDutyLogs implements Action {
  public readonly type = DutyLogActionTypes.DeleteDutyLogs;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearDutyLogs implements Action {
  public readonly type = DutyLogActionTypes.ClearDutyLogs;
}

export type DutyLogActions =
  | LoadDutyLogs
  | AddDutyLog
  | UpsertDutyLog
  | AddDutyLogs
  | UpsertDutyLogs
  | UpdateDutyLog
  | UpdateDutyLogs
  | DeleteDutyLog
  | DeleteDutyLogs
  | ClearDutyLogs
  | DutyLogEdited;
